<div class="glob">

    <div class="toPrint">
        <img class="logoImp" src="assets/Ixell fond blanc.jpg" alt="" />
        <h2 class="rightImp">Formule</h2>
    </div>

    <div class="MC-text-info-formule">
        <div class="MC-text-info-formule-div">
            <h5>
                {{infoFormule}}
            </h5>
        </div>
    </div>

    <div class="actionButtons noPrint">
        <div class="actionButtons-container">
            <button class="QRcode print" (click)="printForm()">
                <i aria-hidden="true" class="fal fa-print color-white fa-3x"></i>
            </button>
            <button class="QRcode" (click)="openQrCode()">
                <img class="QRcode-img" src="assets/qr-code.png" alt="" />
                QRCODE
            </button>

            <button *ngIf="isCtc" class="QRcode" (click)="openCategoryTarif()">
                <i aria-hidden="true" class="fal fa-3x color-white fa-calculator"></i>
            </button>

            <button *ngIf="coucheFormuleCourante && coucheFormuleCourante.components && coucheFormuleCourante.components.length > 0 && isCtc" class="QRcode PAE-RTU" (click)="openChoixPAE_DLL()">
                <div class="PAE-RTU-text">PAE</div>
                <div class="PAE-RTU-text">RTU</div>
            </button>
        </div>
    </div>

    <div class="MC-container-formule">

        <div class="MC-formule">
            <div class="MC-formule-div">
                <div class="MC-formule-titre" [ngClass]="versionFormuleCourante.instructions && versionFormuleCourante.instructions.length > 0 ? '' : versionFormuleCourante.isTotalRespray ? 'isTotalRespray' : ''">

                    
                    <h6 *ngIf="versionFormuleCourante.instructions && versionFormuleCourante.instructions.length > 0; else MC_formule_titre1_else">
                        {{ versionFormuleCourante.instructions[0] }}
                    </h6>

                    <ng-template #MC_formule_titre1_else>
                        <h6 *ngIf="versionFormuleCourante.isTotalRespray; else MC_formule_titre2_else">

                            <i class="fas fa-exclamation-triangle fa-lg fa-beat noPrint"></i>

                            <span *ngIf="formule.colorInfo.ownerName == 'Renault' || formule.colorInfo.ownerName ==  'Dacia' || formule.colorInfo.ownerName ==  'Alpine'; else MC_formule_titre3_else">
                                <!-- Renault / Dacia / Alpine -->
                                {{'details.formulePeuApporchante'|translate}}
                            </span>
                            <ng-template #MC_formule_titre2_else>
                                {{'details.sansGarantie'|translate}}
                            </ng-template>
                        </h6>
                        <ng-template #MC_formule_titre2_else>
                            <h6>
                                {{'details.formule'|translate}}
                            </h6>
                        </ng-template>
                    </ng-template>


                    <!--<h6 *ngIf="nomFormule != '';else MC_formule_titre_else">{nomFormule}}</h6>
    <ng-template #MC_formule_titre_else>
        <h6>
            {'details.formule'|translate}}
        </h6>
    </ng-template>-->
                </div>
                <div class="MC-formule-couche">
                    <!--<div *ngIf="versionFormuleCourante.primer && versionFormuleCourante.primer.components && versionFormuleCourante.primer.components.length > 0" class="MC-formule-couche-primaire MC-formule-couche-div {activeCouchePrimer}}" (click)="SelectCouche(0)">-->
                    <div *ngIf="versionFormuleCourante.primer && versionFormuleCourante.primer.components" class="MC-formule-couche-primaire MC-formule-couche-div {{activeCouchePrimer}}">
                        <span *ngIf="versionFormuleCourante.primer.layerName;else MC_formule_couche_primaire_else">
                            {{versionFormuleCourante.primer.layerName}}
                        </span>
                        <ng-template #MC_formule_couche_primaire_else>
                            {{'search.primaire'|translate}}
                        </ng-template>
                    </div>
                    <div *ngIf="versionFormuleCourante.layer1 && versionFormuleCourante.layer1.components && versionFormuleCourante.layer1.components.length > 0" class="MC-formule-couche-1 MC-formule-couche-div {{activeCouche1}}" (click)="SelectCouche(1)">
                        <span *ngIf="versionFormuleCourante.layer1.layerName;else MC_formule_couche_1_else">
                            {{versionFormuleCourante.layer1.layerName}}
                        </span>
                        <ng-template #MC_formule_couche_1_else>
                            {{'search.couche1'|translate}}
                        </ng-template>
                    </div>
                    <div *ngIf="versionFormuleCourante.layer2 && versionFormuleCourante.layer2.components && versionFormuleCourante.layer2.components.length > 0" class="MC-formule-couche-2 MC-formule-couche-div {{activeCouche2}}" (click)="SelectCouche(2)">
                        <span *ngIf="versionFormuleCourante.layer2.layerName;else MC_formule_couche_2_else">
                            {{versionFormuleCourante.layer2.layerName}}
                        </span>
                        <ng-template #MC_formule_couche_2_else>
                            {{'search.couche2'|translate}}
                        </ng-template>
                    </div>
                </div>
                <div *ngIf="coucheFormuleCourante && coucheFormuleCourante.components && coucheFormuleCourante.components.length > 0" class="MC-formule-ingredientCouche">


                    <mat-table *ngIf="coucheFormuleCourante && coucheFormuleCourante.components && coucheFormuleCourante.components.length > 0; else formuleTab_noProduct_else"
                               [dataSource]="coucheFormuleCourante.components"
                               id="formuleTab"
                               class="noPrint"
                               (contentChanged)="initFooter()">
                        <ng-container matColumnDef="code">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.tabCode'"></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{{res.code}}</span></mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                            </ng-container>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.name'"></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{{res.tonerDescription}}</span></mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                            </ng-container>
                        </ng-container>
                        <ng-container matColumnDef="weight">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.weight'"></mat-header-cell>
                            <mat-cell *matCellDef="let res">{{res.absoluteValue * qte / densiteFormule | number : '1.1-1'}}</mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                            </ng-container>
                        </ng-container>
                        <ng-container matColumnDef="cumul">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.sum'"></mat-header-cell>
                            <mat-cell *matCellDef="let res">{{res.cumulativeValue * qte / densiteFormule | number : '1.1-1'}}</mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef><span *ngIf="category">Coût total :</span></mat-footer-cell>
                            </ng-container>
                        </ng-container>

                        <ng-container matColumnDef="prix">
                            <mat-header-cell *matHeaderCellDef>{{'renting.rentingPrix' | translate}} (€)</mat-header-cell>
                            <mat-cell *matCellDef="let res">
                                {{res.prixAuLitre * ((res.absoluteValue * qte / densiteFormule) / res.density / 1000) | number : '1.1-2'}}
                            </mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef>
                                    {{prixLitreTotal() | number : '1.1-2'}}
                                </mat-footer-cell>
                            </ng-container>
                        </ng-container>


                        <mat-header-row [ngClass]="'formuleTabRowHeader'" *matHeaderRowDef="displayedColumns;"></mat-header-row>
                        <mat-row [ngClass]="'formuleTabRow'" *matRowDef="let row; columns: displayedColumns"></mat-row>
                        <ng-container>
                            <mat-footer-row [ngClass]="'formuleTabRowFooter'" *matFooterRowDef="displayedColumns;"></mat-footer-row>
                        </ng-container>
                    </mat-table>

                </div>
                <ng-template #formuleTab_noProduct_else>
                    <div class="MC-formule-noIngredientCouche">
                        <div>
                            <h3>
                                {{'search.formuleIndisponible'|translate}}
                            </h3>
                        </div>
                    </div>
                </ng-template>

                <div *ngIf="coucheFormuleCourantePAE && coucheFormuleCourantePAE.components && coucheFormuleCourantePAE.components.length > 0 && haveDilutionPAE" class="MC-formule-ingredientCouche">

                    <mat-table *ngIf="coucheFormuleCourantePAE && coucheFormuleCourantePAE.components && coucheFormuleCourantePAE.components.length > 0"
                               [dataSource]="coucheFormuleCourantePAE.components"
                               id="formuleTab"
                               class="noPrint"
                               (contentChanged)="initFooter()">
                        <ng-container matColumnDef="code">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.tabCode'"></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{{res.code}}</span></mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                            </ng-container>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.name'"></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{{res.tonerDescription}}</span></mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                            </ng-container>
                        </ng-container>
                        <ng-container matColumnDef="weight">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.weight'"></mat-header-cell>
                            <mat-cell *matCellDef="let res">{{res.absoluteValue * qte / densiteFormule | number : '1.1-1'}}</mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                            </ng-container>
                        </ng-container>
                        <ng-container matColumnDef="cumul">
                            <mat-header-cell *matHeaderCellDef [translate]="'details.sum'"></mat-header-cell>
                            <mat-cell *matCellDef="let res">{{res.cumulativeValue * qte / densiteFormule | number : '1.1-1'}}</mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef><span *ngIf="category">Coût total :</span></mat-footer-cell>
                            </ng-container>
                        </ng-container>

                        <ng-container matColumnDef="prix">
                            <mat-header-cell *matHeaderCellDef>{{'renting.rentingPrix' | translate}} (€)</mat-header-cell>
                            <mat-cell *matCellDef="let res">
                                {{res.prixAuLitre * ((res.absoluteValue * qte / densiteFormule) / res.density / 1000) | number : '1.1-2'}}
                            </mat-cell>
                            <ng-container>
                                <mat-footer-cell *matFooterCellDef>
                                    {{prixLitreTotalPAE() | number : '1.1-2'}}
                                </mat-footer-cell>
                            </ng-container>
                        </ng-container>


                        <mat-header-row [ngClass]="'formuleTabRowHeader'" *matHeaderRowDef="displayedColumns;"></mat-header-row>
                        <mat-row [ngClass]="'formuleTabRow'" *matRowDef="let row; columns: displayedColumns"></mat-row>
                        <ng-container>
                            <mat-footer-row [ngClass]="'formuleTabRowFooter'" *matFooterRowDef="displayedColumns;"></mat-footer-row>
                        </ng-container>
                    </mat-table>

                </div>

            </div>
        </div>

        <div class="MC-formule-detailGlobal">
            <div class="MC-formule-detailGlobal-div">
                <div id="MC-formule-detailGlobal-imgCouleur" class="MC-formule-detailGlobal-vignetteCouleur noPrint"></div>
                <div id="MC-formule-detailGlobal-imgCouleur-print" class="MC-formule-detailGlobal-vignetteCouleur toPrint">
                    <img alt="" id="MC-formule-detailGlobal-imgCouleur-print-img" src="{{formule.formula.colorOnDisplayUri}}">
                </div>
                <div class="MC-formule-detailGlobal-lignePeinture">

                    <div *ngIf="listeLignePeintureSelect.length == 1;else MC_formule_lignePeinture_else" class="MC_formule_lignePeinture_row">
                        {{listeLignePeintureSelect[0]}}
                    </div>
                    <ng-template #MC_formule_lignePeinture_else>

                        <mat-form-field>
                            <mat-label>{{'details.line' | translate}}</mat-label>
                            <mat-select [(value)]="lignePeinture" (selectionChange)="SelectLignePeinture($event)">
                                <mat-option *ngFor="let lignePeinture of listeLignePeintureSelect; let i = index" class="MC_formule_lignePeinture_rowOption" value="{{lignePeinture}}">{{lignePeinture}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!--<select id="MC-formule-detailGlobal-lignePeinture-select" class="MC-formule-detailGlobal-lignePeinture-select" (change)="SelectLignePeinture()">
                            <option *ngFor="let lignePeinture of listeLignePeintureSelect; let i = index" class="MC_formule_lignePeinture_rowOption" [ngClass]="{'active' : i == indexLignePeintureCourante}">
                                {lignePeinture}}
                            </option>
                        </select>-->

                    </ng-template>
                </div>

                <div class="MC-formule-detailGlobal-version">
                    <div class="MC-formule-detailGlobal-version-title">
                        {{'common.version'|translate}}
                    </div>
                    <div *ngIf="formule.formula.formulaVersions.length == 1;else MC_formule_version_else" class="MC_formule_version_rowVersion solo">
                        {{formule.formula.formulaVersions[0].versionDate | date:'dd/MM/yyyy'}} - v{{formule.formula.formulaVersions[0].versionIdentifier}} <span *ngIf="formule.formula.formulaVersions[0].isEasydose"> (Easy Dose)</span>
                    </div>
                    <ng-template #MC_formule_version_else>
                        <div *ngFor="let version of formule.formula.formulaVersions; let i = index" class="MC_formule_version_rowVersion" [ngClass]="{'active' : i == indexVersionFormuleCourante}" (click)="SelectVersion(i)">
                            {{version.versionDate | date:'dd/MM/yyyy'}} - v{{version.versionIdentifier}} <span *ngIf="version.isEasydose"> (Easy Dose)</span>
                        </div>
                    </ng-template>
                </div>
                <div class="MC-formule-detailGlobal-affichage">
                    <div *ngIf="coucheFormuleCourante && coucheFormuleCourante.minimalAmount; else MC_formule_detailGlobal_affichage_else" class="MC-formule-detailGlobal-affichage-qte">

                        <div class="actionSlider-label">
                            <label class="qteLbl"><span>{{'details.quantitySansUnite'|translate}}</span></label>
                            <mat-select class="noPrint selectUniteFormule" [(value)]="uniteSelected" (selectionChange)="selectUniteFormule()">
                                <mat-option class="selectUniteFormuleOption" value="L">{{'details.uniteLitre'|translate}}</mat-option>
                                <mat-option class="selectUniteFormuleOption" value="Kg">{{'details.uniteKg'|translate}}</mat-option>
                            </mat-select>
                            <label class="toPrint">:{{qte}} <span *ngIf="uniteSelected == 'L'; else uniteSelectedToPrintElse">{{'details.litre'|translate}}</span><ng-template #uniteSelectedToPrintElse><span>{{'details.kilogramme'|translate}}</span></ng-template></label>
                        </div>
                        <div class="actionSlider-input noPrint">
                            <input type="number" id="qte" [(ngModel)]="qte" min="{{coucheFormuleCourante.minimalAmount}}" max="7" step="0.01" (keyup.enter)="hideKeyboard()" />
                        </div>
                        <div id="qteSlider" class="noPrint">
                            <mat-slider min="{{coucheFormuleCourante.minimalAmount}}" max="7" step="0.01" value="1" discrete showTickMarks>
                                <input matSliderThumb [(ngModel)]="qte">
                            </mat-slider>
                        </div>
                    </div>
                    <ng-template #MC_formule_detailGlobal_affichage_else>
                        <div class="MC-formule-detailGlobal-affichage-qte">
                            <div class="actionSlider-label">
                                <label class="qteLbl"><span>{{'details.quantitySansUnite'|translate}}</span></label>
                                <mat-select class="noPrint selectUniteFormule" [(value)]="uniteSelected" (selectionChange)="selectUniteFormule()">
                                    <mat-option class="selectUniteFormuleOption" value="L">{{'details.uniteLitre'|translate}}</mat-option>
                                    <mat-option class="selectUniteFormuleOption" value="Kg">{{'details.uniteKg'|translate}}</mat-option>
                                </mat-select>
                                <label class="toPrint">:{{qte}} <span *ngIf="uniteSelected == 'L'; else uniteSelectedToPrintElse">{{'details.litre'|translate}}</span><ng-template #uniteSelectedToPrintElse><span>{{'details.kilogramme'|translate}}</span></ng-template></label>
                            </div>
                            <div class="actionSlider-input noPrint">
                                <input class="noPrint" type="number" id="qte" [(ngModel)]="qte" min="0.05" max="7" step="0.01" (keyup.enter)="hideKeyboard()" />
                            </div>
                            <div id="qteSlider noPrint">
                                <mat-slider min="0.01" max="7" step="0.01" value="1" discrete showTickMarks>
                                    <input matSliderThumb [(ngModel)]="qte">
                                </mat-slider>
                            </div>
                        </div>
                    </ng-template>

                    <div *ngIf="coucheFormuleCourante && coucheFormuleCourante.minimalAmount" class="qteMinimum noPrint">
                        {{'details.quantityMinimum'|translate}} <span class="qteMinimum-montant">{{coucheFormuleCourante.minimalAmount}}</span><span class="qteMinimum-unite">L</span>
                    </div>
                </div>

            </div>
        </div>


    </div>




    <div *ngIf="coucheFormuleCourante && coucheFormuleCourante.components && coucheFormuleCourante.components.length > 0" class="MC-formule-ingredientCouche">

        <table *ngIf="coucheFormuleCourante && coucheFormuleCourante.components && coucheFormuleCourante.components.length > 0; else formuleTab_noProduct_else2" class="table lstIngrFormule table-responsive toPrint">
            <caption></caption>
            <thead>
                <tr>
                    <th scope="col">{{ 'details.tabCode' | translate}}</th>
                    <th scope="col">{{ 'details.name' | translate}}</th>
                    <th scope="col">{{ 'details.weight' | translate}} </th>
                    <th scope="col">{{ 'details.sum' | translate}}</th>
                    <th *ngIf="category" scope="col">{{ 'renting.rentingPrix' | translate}} (€)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let res of coucheFormuleCourante.components">
                    <td class="rightMargin">{{ res.code }}</td>
                    <td class="rightMargin">{{ res.tonerDescription }}</td>
                    <td>{{res.absoluteValue * qte / densiteFormule | number : '1.1-1'}}</td>
                    <td>{{res.cumulativeValue * qte / densiteFormule | number : '1.1-1'}}</td>
                    <td *ngIf="category">{{res.prixAuLitre * ((res.absoluteValue * qte / densiteFormule) / res.density / 1000) | number : '1.1-2'}}</td>
                </tr>
            </tbody>
            <tfoot class="formuleTabRowFooter">
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><span *ngIf="category">Coût total :</span></td>
                    <td *ngIf="category">{{prixLitreTotal() | number : '1.1-2'}}</td>
                </tr>
            </tfoot>
        </table>
    </div>
    <ng-template #formuleTab_noProduct_else2>
        <div class="MC-formule-noIngredientCouche">
            <div>
                <h3>
                    {{'search.formuleIndisponible'|translate}}
                </h3>
            </div>
        </div>
    </ng-template>

    <div *ngIf="coucheFormuleCourantePAE && coucheFormuleCourantePAE.components && coucheFormuleCourantePAE.components.length > 0 && haveDilutionPAE" class="MC-formule-ingredientCouche breakPageAlways">

        <table *ngIf="coucheFormuleCourantePAE && coucheFormuleCourantePAE.components && coucheFormuleCourantePAE.components.length > 0" class="table lstIngrFormule table-responsive toPrint">
            <caption></caption>
            <thead>
                <tr>
                    <th scope="col">{{ 'details.tabCode' | translate}}</th>
                    <th scope="col">{{ 'details.name' | translate}}</th>
                    <th scope="col">{{ 'details.weight' | translate}} </th>
                    <th scope="col">{{ 'details.sum' | translate}}</th>
                    <th *ngIf="category" scope="col">{{ 'renting.rentingPrix' | translate}} (€)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let res of coucheFormuleCourantePAE.components">
                    <td class="rightMargin">{{ res.code }}</td>
                    <td class="rightMargin">{{ res.tonerDescription }}</td>
                    <td>{{res.absoluteValue * qte / densiteFormule | number : '1.1-1'}}</td>
                    <td>{{res.cumulativeValue * qte / densiteFormule | number : '1.1-1'}}</td>
                    <td *ngIf="category">{{res.prixAuLitre * ((res.absoluteValue * qte / densiteFormule) / res.density / 1000) | number : '1.1-2'}}</td>
                </tr>
            </tbody>
            <tfoot class="formuleTabRowFooter">
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><span *ngIf="category">Coût total :</span></td>
                    <td *ngIf="category">{{prixLitreTotalPAE() | number : '1.1-2'}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="toPrint centerqr" *ngIf="qrcode">
        <img src="data:image/png;base64,{{qrcode}}" alt="" />
    </div>


    <div id="Modal" class="modal noPrint">
        <div class="modal-content">
            <div class="centerqr" *ngIf="qrcode">
                <img src="data:image/png;base64,{{qrcode}}" alt="" />
            </div>
            <button class="mx-auto" (click)="closeModal()">{{'activlist.fermer'|translate}}</button>
        </div>
    </div>


    <div id="ModalCategoryTarif" class="modal noPrint">
        <div class="modal-content">

            <div>
                <mat-radio-group [(ngModel)]="category">
                    <div>
                        <mat-radio-button (change)="setCategoryCtc($event)" value="">{{'references.TarifCategory'|translate}}</mat-radio-button>
                    </div>

                    <div *ngIf="listCategorie.length > 0">{{libTarif}}</div>
                    <div *ngIf="listCategorie.length > 0">
                        <div *ngFor="let cat of listCategorie">
                            <mat-radio-button (change)="setCategoryCtc($event)" value="{{cat}}">{{cat}}</mat-radio-button>
                        </div>
                    </div>

                    <mat-radio-button *ngIf="listCategorie.length == 0" (change)="setCategoryGeneriqueCtc($event)" value="generique">{{libTarif}}</mat-radio-button>


                </mat-radio-group>
            </div>

            <button class="mx-auto" (click)="closeCategoryTarif()">{{'activlist.fermer'|translate}}</button>
        </div>
    </div>

</div>


<div id="ModalDLL_PAE" class="modal noPrint">
    <div class="modal-content">

        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeChoixPAE_DLL();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title">Equinox</h1>
            <h4 class="modal-subtitle">
                {{subtitlePAEDLL}}
            </h4>
            <hr />
        </div>

        <!--<div *ngIf="seeListChoixVernis && !seeColorWebPAE" class="ModalDLL_PAE-ListChoixVernis">

            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('690')">Flash (Vernis flash)</div>
            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('766')">Flash evolution (Vernis flash evo)</div>
            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('517')">Ixalis-evol (Ixalis evolution)</div>
            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('718')">Lexiclear (Vernis lexiclear)</div>

        </div>-->

        <div *ngIf="!seeListChoixVernis && seeColorWebPAE" class="ModalDLL_PAE-ixellColorWebPAE">

            <div class="listChoixColorWebPAE">

                <div *ngIf="haveDilutionPAE_jauge" class="ModalDLL_PAE-jaugeSelectionPourcentage">
                    <div class="actionSlider-input">
                        <input type="number" id="choixJaugeIxellColorWebPAE" [(ngModel)]="choixJaugeIxellColorWebPAE.ratioChoix" [min]="choixJaugeIxellColorWebPAE.ratio1" [max]="choixJaugeIxellColorWebPAE.ratio2" [step]="1" (keyup.enter)="hideKeyboard()" />
                    </div>
                    <div id="qteSlider noPrint">
                        <mat-slider [min]="choixJaugeIxellColorWebPAE.ratio1" [max]="choixJaugeIxellColorWebPAE.ratio2" [step]="1" discrete showTickMarks>
                            <input matSliderThumb [(ngModel)]="choixJaugeIxellColorWebPAE.ratioChoix">
                        </mat-slider>
                    </div>

                </div>

                <div *ngIf="!haveDilutionPAE_quadrillage && !haveDilutionPAE_vehicule && !haveDilutionPAE_jauge">
                    <div *ngFor="let choix of ixellColorWebPAECourant" class="ModalDLL_PAE-choixIxellColorWebPAE" (click)="GetOptionDillutionPAE(choix)">
                        <span *ngIf="choix.messagesol1; else elseChoixMessage">{{choix.messagesol1}}</span>
                        <ng-template #elseChoixMessage>
                            {{choix.bnom}} [{{choix.bcode}}]
                        </ng-template>
                    </div>
                </div>

                <div *ngIf="haveDilutionPAE_quadrillage && !haveDilutionPAE_vehicule && !haveDilutionPAE_jauge" class="ModalDLL_PAE-choixQuadrillage">

                    <div class="choixQuadrillageRow firstRow">
                        <div class="choixQuadrillageCell firstCell">40°C</div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell"></div>
                        <div class="choixQuadrillageCell choixCase-4" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-4" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-4 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell">35°C</div>
                        <div class="choixQuadrillageCell choixCase-4" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-4" (click)="GetOptionDillutionPAEEquinox(4)">4</div>
                        <div class="choixQuadrillageCell choixCase-4 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell"></div>
                        <div class="choixQuadrillageCell choixCase-4" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-4" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-4 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell">30°C</div>
                        <div class="choixQuadrillageCell choixCase-4 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-4 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(4)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3" (click)="GetOptionDillutionPAEEquinox(3)">3</div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-3 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(3)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell">25°C</div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2" (click)="GetOptionDillutionPAEEquinox(2)">2</div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-2 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(2)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)">1</div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell">20°C</div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1" (click)="GetOptionDillutionPAEEquinox(1)">1</div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-1 choixCase-borderBottom choixCase-borderRight" (click)="GetOptionDillutionPAEEquinox(1)"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0">X</div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow">
                        <div class="choixQuadrillageCell firstCell">15°C</div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                        <div class="choixQuadrillageCell choixCase-0"></div>
                    </div>
                    <div class="choixQuadrillageRow lastRow">
                        <div class="choixQuadrillageCell"></div>
                        <div class="choixQuadrillageCell">0</div>
                        <div class="choixQuadrillageCell">10%</div>
                        <div class="choixQuadrillageCell">20%</div>
                        <div class="choixQuadrillageCell">30%</div>
                        <div class="choixQuadrillageCell">40%</div>
                        <div class="choixQuadrillageCell">50%</div>
                        <div class="choixQuadrillageCell">60%</div>
                        <div class="choixQuadrillageCell">70%</div>
                        <div class="choixQuadrillageCell">80%</div>
                        <div class="choixQuadrillageCell">90%</div>
                    </div>


                </div>

                <div *ngIf="!haveDilutionPAE_quadrillage && haveDilutionPAE_vehicule && !haveDilutionPAE_jauge" class="ModalDLL_PAE-choixVehicule">

                    <table id="dilutionPAE_vehicule">

                        <thead>
                            <tr>
                                <th></th>
                                <th><img src="assets/MixitCloud/Equinox_unique.png" id="equinoxImgPAE-Unique"class="equinoxImagePAE" /></th>
                                <th><img src="assets/MixitCloud/Equinox_lateral.png" id="equinoxImgPAE-Lateral"class="equinoxImagePAE" /></th>
                                <th><img src="assets/MixitCloud/Equinox_demi.png" id="equinoxImgPAE-Demi"class="equinoxImagePAE" /></th>
                                <th><img src="assets/MixitCloud/Equinox_Complet.png" id="equinoxImgPAE-Complet"class="equinoxImagePAE" /></th>
                            </tr>
                        </thead>

                        <tbody>
                            <!--<tr *ngFor="let res of listChoixIxellColorWebPAEVehicule">
                                <td [attr.rowspan]="1" [attr.colspan]="1"><span class="rightMargin">{res.titreRow}}</span></td>
                                <td [attr.rowspan]="1" [attr.colspan]="1"><span class="rightMargin">{res.lateral}}</span></td>
                                <td [attr.rowspan]="1" [attr.colspan]="1"><span class="rightMargin">{res.lateral}}</span></td>
                                <td [attr.rowspan]="1" [attr.colspan]="1"><span class="rightMargin">{res.demi}}</span></td>
                                <td [attr.rowspan]="1" [attr.colspan]="1"><span class="rightMargin">{res.complet}}</span></td>
                            </tr>-->


                            <tr *ngFor="let res of listChoixIxellColorWebPAEVehicule">

                                <td *ngFor="let res2 of res.rowDilutionPAEEquinox" [attr.colspan]="res2.cellspan" class="{{res2.classspan}}" (click)="selectDilutionPAE_vehicule(res2.zoneApplication, res2.degreApplication)"><span class="">{{res2.cellvalue}}</span></td>
                            </tr>

                        </tbody>

                    </table>

                    <!--<mat-table [dataSource]="listChoixIxellColorWebPAEVehicule" id="dilutionPAE_vehicule">

                        <ng-container matColumnDef="valNPlus1">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{res.titreRow}}</span></mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="unique">
                            <mat-header-cell *matHeaderCellDef><img src="assets/MixitCloud/Equinox_unique.png" id="equinoxImgPAE-Unique" /></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{res.unique}}</span></mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="lateral">
                            <mat-header-cell *matHeaderCellDef><img src="assets/MixitCloud/Equinox_lateral.png" id="equinoxImgPAE-Lateral" /></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{res.lateral}}</span></mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="demi">
                            <mat-header-cell *matHeaderCellDef><img src="assets/MixitCloud/Equinox_demi.png" id="equinoxImgPAE-Demi" /></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{res.demi}}</span></mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="complet">
                            <mat-header-cell *matHeaderCellDef><img src="assets/MixitCloud/Equinox_Complet.png" id="equinoxImgPAE-Complet" /></mat-header-cell>
                            <mat-cell *matCellDef="let res"><span class="rightMargin">{res.complet}}</span></mat-cell>
                        </ng-container>


                        <mat-header-row [ngClass]="'dilutionPAE_vehiculeTabRowHeader'" *matHeaderRowDef="displayedColumnsDillutionVehicule;"></mat-header-row>
                        <mat-row [ngClass]="'dilutionPAE_vehiculeTabRow'" *matRowDef="let row; columns: displayedColumnsDillutionVehicule"></mat-row>

                    </mat-table>-->

                </div>

                <div class="ModalDLL_PAE-choixQuadrillage-jauge">

                </div>

            </div>

            <div class="tableSelectionColorWebPAE">
                <table class="tableColorWebPAE table table-bordered">
                    <thead class="theadColorWebPAE">
                        <tr class="rowColorWebPAE">
                            <th class="cellColorWebPAE">{{'details.code'|translate}}</th>
                            <th class="cellColorWebPAE">{{'details.designation'|translate}}</th>
                            <th class="cellColorWebPAE">{{'details.ratio'|translate}}</th>
                        </tr>
                    </thead>
                    <tbody class="tbodyColorWebPAE">

                        <tr *ngFor="let selectedColorWebPAE of listChoixIxellColorWebPAE" class="rowColorWebPAE rowColorWebPAE-cleappli-{{selectedColorWebPAE.cleappli}} rowColorWebPAE-typesol-{{selectedColorWebPAE.typesol}}">
                            <td class="cellColorWebPAE">
                                <span *ngIf="selectedColorWebPAE.bnum != 0">
                                    {{selectedColorWebPAE.bcode}}
                                </span>
                            </td>
                            <td class="cellColorWebPAE">
                                <span *ngIf="selectedColorWebPAE.bnum == 0; else selectedColorWebPAEbnom">
                                    {{selectedColorWebPAE.titre1}}
                                </span>
                                <ng-template #selectedColorWebPAEbnom>
                                    {{selectedColorWebPAE.bnom}}
                                </ng-template>
                            </td>
                            <td class="cellColorWebPAE">

                                <span *ngIf="selectedColorWebPAE.codeMethode == 0; else codeMethodeEgal1">{{selectedColorWebPAE.ratioChoix | number : '1.2-3'}}%</span>
                                <ng-template #codeMethodeEgal1>
                                    <span *ngIf="selectedColorWebPAE.bvolume == 0; else bvolumeEgal1">{{selectedColorWebPAE.ratioChoix | number : '1.2-3'}}g</span>
                                </ng-template>
                                <ng-template #bvolumeEgal1>
                                    <span *ngIf="selectedColorWebPAE.ratioChoix > 0">{{selectedColorWebPAE.ratioChoix | number : '1.2-3'}}</span>
                                </ng-template>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>

        <div class="listeBoutonDilution">
            <button *ngIf="!haveDilutionPAE_jauge && buttonCloseDilution" class="mx-auto" (click)="closeChoixPAE_DLL()">{{'activlist.fermer'|translate}}</button>
            <button *ngIf="!haveDilutionPAE_jauge && buttonPrevDilution" class="mx-auto" (click)="prevChoixPAE_DLL()">{{'scaleform.precedent'|translate}}</button>
            <button *ngIf="!haveDilutionPAE_jauge && buttonNextDilution" class="mx-auto" (click)="nextChoixPAE_DLL()">{{'scaleform.suivant'|translate}}</button>
            <button *ngIf="haveDilutionPAE_jauge" class="mx-auto" (click)="GetValueRatioOptionDillutionPAE()">{{'scaleform.suivant'|translate}}</button>

        </div>
    </div>
</div>
